export default "__VITE_ASSET__9c6fe794__"